<template>
  <el-dialog
    :visible.sync="showEdit"
    width="60%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    title="发布文章"
    @closed="handleClose"
    :close-on-click-modal="false"
    class="axj-post-edit"
  >
    <div style="margin-top: -20px">
      <el-radio-group size="mini" @change="handlePostTypeChange" v-model="postType">
        <el-radio-button label="院校张贴"></el-radio-button>
        <el-radio-button label="部门张贴"></el-radio-button>
      </el-radio-group>
    </div>
    <school-post-edit
      v-show="postType=='院校张贴'"
      :post-id="postEdit.postId"
      :is-create="postEdit.create"
      ref="schoolPost"
      @close="handleClose"
      @updated="handleUpdated"
      @created="handleCreated"
    />
    <department-post-edit
      v-show="postType=='部门张贴'"
      :post-id="postEdit.postId"
      :is-create="postEdit.create"
      ref="departmentPost"
      @close="handleClose"
      @updated="handleUpdated"
      @created="handleCreated"
    />
  </el-dialog>
</template>

<script>
import SchoolPostEdit from "./component/school-post-edit";
import DepartmentPostEdit from "./component/department-post-edit";
export default {
  components: {DepartmentPostEdit, SchoolPostEdit},
  name: "axj-post-edit",
  methods:{
    handleClose(){
      this.$emit("update:show",false)
    },
    handleOpen(){
      this.$nextTick(()=>{
        if(this.postType!='部门张贴'){
          this.$refs.schoolPost.handleOpen()
        }else{
          this.$refs.departmentPost.handleOpen()
        }
      })
    },
    handlePostTypeChange(){
      if(this.postType=='部门张贴'){
        this.$refs.departmentPost.handleOpen()
      }else{
        this.$refs.schoolPost.handleOpen()
      }
    },
    handleUpdated(){
     this.$emit('updated')
    },
    handleCreated(){
     this.$emit('created')
    }
  },
  mounted() {
  },
  props:{
    show:{
      type:Boolean,
      default:false
    },
    isCreate:true,
    postId:undefined,
    cPostType:undefined
  },
  data(){
    return{
      showEdit:false,
      postType:'院校张贴',
      postEdit:{
        create:true,
        show:false,
        postId:undefined,
      }
    }
  },
  watch:{
    show(v){
      this.showEdit=v
    },
    isCreate(v){
      this.postEdit.create=v
    },
    postId(v){
      this.postEdit.postId=v
    },
    cPostType(v){
      this.postType=v
    }
  }
}
</script>

<style lang="scss" slot-scope>
.axj-post-edit{
  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #FFF;
    background-color: #41555d;
    border-color: #41555d;
    -webkit-box-shadow: -1px 0 0 0 #41555d;
    box-shadow: -1px 0 0 0 #41555d;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-post/action/axj-post-edit.vue